import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class HttpErrorHandlerService {
  public handleError(error: unknown): void {
    // TODO: Implement a proper error handling strategy for HTTP comms
    console.error('An HTTP error occurred:', error);
  }
}
